<template>
  <slideover ref="slideover" v-if="visible" title="Crea ticket" @close="visible = false">
    <template v-slot:content>
      <div class="space-y-2 h-full flex flex-col">
        <ic :e="errors.type">
          <label>Reparto</label>
          <select v-model="ticket.type">
            <option :value="id" v-for="({id, description}) in ticket_types">{{ description }}</option>
          </select>
          <small v-if="ticket.type">
            <span v-if="ticket.type === 1">Modifica Politiche Commerciali, Pagamenti, Ordini</span>
            <span v-else-if="ticket.type === 4">Segnala presenza di errori nei dati dei prodotti</span>
            <span v-else-if="ticket.type === 5">Segnala malfunzionamenti, esponi consigli, richieste, domande riguardanti la piattaforma</span>
          </small>
        </ic>
        <ic :e="errors.title">
          <label>Titolo</label>
          <input type="text" v-model="ticket.title">
        </ic>
        <ic c="flex-grow flex flex-col" :e="errors.message">
          <label>Messaggio</label>
          <textarea class="resize-none flex-grow" v-model="ticket.message"></textarea>
        </ic>
      </div>
    </template>
    <template v-slot:actions>
      <div class="flex justify-end w-full">
        <div class="btn btn-primary" @click="store()">Invia ticket</div>
      </div>
    </template>
  </slideover>
</template>

<script>
export default {
  name: "create_ticket",
  watch: {
    visible: {
      immediate: true,
      handler(new_value) {
        if (!this.visible) this.router = null;
        this.$nextTick(() => {
          new_value ? this.$refs.slideover.open() : (this.$refs.slideover ? () => {
            this.$refs.slideover.close();
          } : null)
        })
        if (!this.visible && !this.first) this.close();
      }
    }
  },
  methods: {
    open(obj) {
      console.log(obj);
      this.ticket = {
        type: obj.flag || 1,
        title: obj.title || null,
        message: obj.message || null,
        subject_type: obj.ticket_class || null,
        subject_id: obj.id || null,
        open: obj.open || false
      };
      this.errors = {};
      this.visible = true;
      if(this.ticket.open){
        this.$nextTick( () => this.store());
      }
    },
    async store() {
      this.$refs.slideover.set_loading(true);
      let ticket = null;
      try {
        ticket = (await axios.post('/assistenza/tickets', this.ticket)).data;
        this.$refs.slideover.set_loading(false);
        await this.$refs.slideover.close();
        await this.$router.push({name: 'tickets.show', params: {id: ticket.id}});
      } catch (e) {
        this.errors = e.response.data.errors;
        this.$refs.slideover.set_loading(false);
      }
    },
    close() {
      document.querySelector('body').style.overflowY = null;
    }
  },
  data: () => ({
    visible: false,
    ticket_types: [],
    ticket: {
      type: null,
      title: null,
      message: null,
      subject_type: null,
      subject_id: null,
    },
    errors: {},
    router: null,
    first: true,
  }),
  async mounted() {
    this.$emitter.on('open_ticket', this.open);
    let baseURL = null;
    //baseURL = 'http://led-italia-v3.test';
    baseURL = 'https://led-italia.it';
    this.ticket_types = (await axios({
      url: '/bender2/enum',
      baseURL: baseURL,
      method: 'GET',
      params: {
        enum: 'App\\Domain\\Ticketing\\Enums\\TicketTypeEnum'
      }
    })).data;

    this.first = false;

  }
}
</script>
